export const BILLING_SECTION_IDS = {
  plans: 'plan',
  funds: 'funds',
  payment: 'payment',
  history: 'history',
}
